import type {
    LibraryDiagram,
    LibraryImage,
    LibraryVideo,
} from '@modules/product/type/product-gallery-types';

interface GallerySlidesProps {
    LibraryImages: LibraryImage[];
    LibraryVideos: LibraryVideo[];
    DiagramImages: LibraryDiagram[];
}

const getGallerySlides = ({
    LibraryImages,
    LibraryVideos,
    DiagramImages,
}: GallerySlidesProps) => {
    const libraryImages = LibraryImages ?? [];
    const libraryVideos = LibraryVideos ?? [];
    const libraryDiagrams = DiagramImages ?? [];

    const sortedImagesVideos: Array<LibraryImage | LibraryVideo> = [
        ...libraryImages,
        ...libraryVideos,
    ].sort((a, b) => b.MemberSortOrder - a.MemberSortOrder);

    const sortedDiagrams: Array<LibraryDiagram> = libraryDiagrams.sort(
        (a, b) => b.MemberSortOrder - a.MemberSortOrder
    );

    return [...sortedImagesVideos, ...sortedDiagrams];
};

export default getGallerySlides;
